import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-tooltip',
  templateUrl: './error-tooltip.component.html',
  styleUrls: ['./error-tooltip.component.scss'],
})
export class ErrorTooltipComponent {
  @Input() tooltipId: string | null = null;
}
